import color from "./color";
import combine from "./combine";
import combineCoords from "./combineCoords";
import coord from "./coord";
import src from "./src";
export default [...src, ...coord, ...color, ...combine, ...combineCoords];
